(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-view/assets/javascripts/pix-mix-skeleton.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-view/assets/javascripts/pix-mix-skeleton.js');

'use strict';

const {
  ReactIcon: Icon,
  ReactIconButton: IconButton
} = svs.ui;
const {
  PixMixImage
} = svs.pix_mix.components.pixmixView;
const {
  Skeleton
} = svs.components.lbUi;
const PixMixSkeleton = () => {
  var _svs$pix_mix$data;
  const {
    ingress,
    image: cmsImage,
    title
  } = ((_svs$pix_mix$data = svs.pix_mix.data) === null || _svs$pix_mix$data === void 0 ? void 0 : _svs$pix_mix$data.initialState) || {};
  const showInfoDialog = e => {
    const dialog = new svs.ui.dialog.Contextual({
      area: svs.ui.dialog.area.CONTEXTUAL,
      branding: svs.ui.dialog.branding.SPORT,
      attachTo: e.target.closest('button'),
      title: '',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: ingress
      }]
    });
    svs.ui.dialog.api.add(dialog);
  };
  return React.createElement("div", {
    className: "pix-mix-view"
  }, title && React.createElement("h2", {
    className: "pix-mix-title"
  }, title, ingress && React.createElement(IconButton, {
    className: "pix-mix-info-btn",
    onClick: showInfoDialog
  }, React.createElement(Icon, {
    icon: "information",
    size: "300"
  }))), cmsImage && React.createElement(PixMixImage, null), React.createElement("div", {
    className: "pix-mix-skeleton-title"
  }, React.createElement(Skeleton, {
    height: 1,
    numLines: 1,
    style: {
      width: '300px'
    }
  }), React.createElement(Skeleton, {
    height: 1,
    numLines: 1,
    style: {
      width: '250px'
    }
  })), React.createElement("div", {
    className: "pix-mix-skeleton-pix-items"
  }, React.createElement(Skeleton, {
    height: 5,
    numLines: 1,
    style: {
      width: '144px'
    }
  }), React.createElement(Skeleton, {
    height: 5,
    numLines: 1,
    style: {
      width: '144px'
    }
  }), React.createElement(Skeleton, {
    height: 5,
    numLines: 1,
    style: {
      width: '144px'
    }
  }), React.createElement(Skeleton, {
    height: 5,
    numLines: 1,
    style: {
      width: '144px'
    }
  })));
};
setGlobal('svs.pix_mix.components.pixmixView.PixMixSkeleton', PixMixSkeleton);

 })(window);